export default __webpack_public_path__ + "static/media/sun-example.9a753015.png";